import React, {Component} from 'react'
import {createMuiTheme, MuiThemeProvider} from '@material-ui/core/styles'
import {deepMerge} from 'utils/CollectionUtils'
import {baseThemeDefinition} from 'styles/AppStyles'
import StyleSheet from 'styles'
import {styles as dtpStyles} from 'components/DateTimePicker'
import {styles as fileUploadStyles} from 'components/FileUploadField'

export class StyledForm extends Component {
  render = () =>
    <MuiThemeProvider theme={formTheme}>
      <div className={[this.props.className, styles.form].filter(c => c).join(' ')} style={this.props.style}>
        {this.props.children}
      </div>
    </MuiThemeProvider>
}

const formTheme =
  createMuiTheme(deepMerge(baseThemeDefinition, {
    typography: {
      h5: {
        padding: [20, 0, 10, 0],
        margin: [0, 10, 30, 0]
      },
      h6: {
        padding: [5, 0]
      },
      subtitle1: {
        paddingTop: 25
      }
    },
    overrides: {
      MuiFormControl: {
        root: {
          width: '50%',
          paddingRight: 10,
          paddingBottom: 10,
          boxSizing: 'border-box'
        }
      },
      MuiFormControlLabel: {
        root: {
          marginRight: 32,
        }
      },
      MuiFormGroup: {
        root: {
          flexDirection: 'row',
        }
      },
      MuiButton: {
        root: {
          width: 266,
          marginRight: 20,
          marginBottom: 20,
        },
        flatPrimary: {
          width: 'auto',
        },
        fullWidth: {
          width: 'calc(100% - 5px)'
        }
      },
      MuiInputLabel: {
        animated: {
          whiteSpace: 'nowrap'
        }
      },
      MuiInput: {
        root: {
          '&$disabled:before': {
            display: 'none'
          }
        }
      }
    }
  }))

const styles = StyleSheet({
  form: {
    width: '100%',
    [`& .${dtpStyles.dateWrapper}`]: {
      width: '50%',
      boxSizing: 'border-box',
      display: 'inline-flex'
    },
    [`& .${fileUploadStyles.wrapper}`]: {
      paddingRight: 10
    },
  },
})